<template>
  <div :class="joinClasses('switch-button', modifiers)">
    <div v-for="item in items" :key="item.value" class="switch-button__item">
      <input
        class="switch-button__input"
        type="radio"
        :name="name"
        :id="itemId(item)"
        :value="item.value"
        :checked="modelValue === item.value"
        @change="$emit('update:modelValue', item.value)"
      />
      <label :class="{ 'switch-button__label': true, [item.class_name]: item.class_name }" :for="itemId(item)">
        <UseSvg :name="item.icon" v-if="item.icon" class="switch-button__icon icon" />
        <div class="switch-button__label-content">
          <span v-if="item.label" class="switch-button__label-text">{{ item.label }}</span>
          <span v-if="item.tag" class="switch-button__label-tag typo-tiny">{{ item.tag }}</span>
        </div>
      </label>
    </div>
  </div>
</template>

<script setup>
import joinClasses from '@/functions/join_classes';

import UseSvg from '@/components/generic/use_svg.vue';

const props = defineProps({
  modelValue: { type: String, default: null },
  name: { type: String, default: null },
  items: { type: Array, required: true },
  modifiers: { type: Array, default: () => [] },
});
defineEmits(['update:modelValue']);

function itemId(item) {
  return `${props.name}_${item.value}`;
}
</script>
